import { render, staticRenderFns } from "./warrantyTimeConfig.vue?vue&type=template&id=45103c28"
import script from "./warrantyTimeConfig.vue?vue&type=script&lang=js"
export * from "./warrantyTimeConfig.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/qualityStyle.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports